import { PaymentAccountHolder } from '@/api/funds/models/PaymentAccountHolder';
import { CurrencyCode } from '@/types/CurrencyCode';

export const createCompositeKey = (
  accountHolder: PaymentAccountHolder,
  currency: CurrencyCode,
): string => {
  return `${accountHolder}-${currency}`;
};
